import { Component, Input, inject, signal, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { Score } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
  selector: 'app-preventional-score',
  templateUrl: './preventional-score.component.html',
  styleUrls: ['./preventional-score.component.scss'],
  standalone: true,
  imports: [TranslateModule, MatProgressSpinnerModule],
  providers: [TranslationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreventionalScoreComponent implements OnChanges {

  @Input() scoreCourant?: Score
  typeScorePrevention = signal<string>('');

  readonly translationService = inject(TranslationService);

  constructor(private readonly cdr: ChangeDetectorRef) { }

  ngOnChanges(): void {
    if (this.scoreCourant) {
      setTimeout(() => {
        this.typeScorePrevention.set(
          Backend.SCORE.typeOfPreventional(this.scoreCourant)
        );
        this.cdr.detectChanges();
      });
    }
  }

  getGreylist() {
    return Backend.SCORE.getGreylist(this.scoreCourant)
  }

  formatScore(score: number | undefined) {
    return Backend.SCORE.formatScore(score)
  }

  getSubScoreBreak() {
    return Backend.SCORE.getSubScoreBreak(this.scoreCourant)
  }

  formatScoreFamily(score: string) {
    return Backend.SCORE.formatScoreFamily(score)
  }

  statutScorePrevention(score: number) {
    return Backend.SCORE.statutFamilyScorePrevention(score)
  }

}
